export default {"src":"/_next/static/media/APH.771a3a02.svg","height":18,"width":18};